import PropTypes from 'prop-types'

import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const IconLocked = ({ color, overrides, ref, size, title }) => {
  const [, theme] = useStyletron()

  title = title ?? 'Locked'
  size = size ?? 16
  color = color ?? theme.colors.primary

  return (
    <Icon ref={ref} viewBox='0 0 24 24' size={size} color={color} overrides={overrides}>
      <title>{title}</title>
      <path d='M12 1C13.3833 1 14.5628 1.48725 15.5381 2.46191C16.5128 3.43725 17 4.61667 17 6V8H18C18.55 8 19.0211 8.19558 19.4131 8.58691C19.8044 8.97891 20 9.45 20 10V20C20 20.55 19.8044 21.0211 19.4131 21.4131C19.0211 21.8044 18.55 22 18 22H6C5.45 22 4.97922 21.8044 4.58789 21.4131C4.1959 21.0211 4 20.55 4 20V10C4 9.45001 4.1959 8.97891 4.58789 8.58691C4.97922 8.19558 5.45 8 6 8H7V6C7 4.61667 7.48757 3.43724 8.46289 2.46191C9.43756 1.48725 10.6167 1 12 1ZM6 20H18V10H6V20ZM12 13C12.55 13 13.0211 13.1956 13.4131 13.5869C13.8044 13.9789 14 14.45 14 15C14 15.55 13.8044 16.0211 13.4131 16.4131C13.0211 16.8044 12.55 17 12 17C11.45 17 10.9792 16.8044 10.5879 16.4131C10.1959 16.0211 10 15.55 10 15C10 14.45 10.1959 13.9789 10.5879 13.5869C10.9792 13.1956 11.45 13 12 13ZM12 3C11.1667 3 10.4583 3.29167 9.875 3.875C9.29167 4.45833 9 5.16667 9 6V8H15V6C15 5.16667 14.7083 4.45833 14.125 3.875C13.5417 3.29167 12.8333 3 12 3ZM24.75 0H23.75V-1H24.75V0Z' />{' '}
    </Icon>
  )
}

IconLocked.propTypes = {
  color: PropTypes.string,
  overrides: PropTypes.object,
  ref: PropTypes.object,
  size: PropTypes.number,
  title: PropTypes.string,
}

export default IconLocked
